import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";

const DetallePeriodoCobro = ({
  displayBasic,
  setDisplayBasic,
  basicDialogFooter,
  modalLoading,
  error,
  fila,
  arriendoDescriptions,
  periodoDeCobro,
  fechaDeEmision,
  vencimiento,
  summary,
  handleCopyDetails,
  ufTipoCambio,
  arriendoItems,
  gastoComunItems,
  serviciosItems,
  obrasCivilesItems,
  exportToPDF,
  exportLoading,
}) => {
  return (
    <Dialog 
      visible={displayBasic} 
      className="p-fluid product-dialog"
      footer={basicDialogFooter} 
      onHide={() => setDisplayBasic(false)}>
      <div id="dialog-content">
        {modalLoading ? (
          <p>Loading...</p>
        ) : error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : (
          <>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px",}}>
              {/* Header Content */}
              <div style={{display: "flex",flexDirection: "column",alignItems: "flex-start",paddingRight: "20px" }}>
                <h4 style={{margin: "0 0 5px 0",fontSize: "1.2rem",fontWeight: "bold", }}>
                  Srs: {fila?.cliente?.razonSocial}
                </h4>
                <p style={{margin: "0 0 5px 0",fontSize: "1rem",color: "#555", }}>
                  RUT: {fila?.cliente?.rut}
                </p>
                <p style={{ margin: 0, fontSize: "1rem", color: "#555" }}>
                  {arriendoDescriptions}
                </p>
              </div>
              <div style={{display: "flex",flexDirection: "column",alignItems: "flex-end",paddingLeft: "20px",borderLeft: "1px solid #ddd", }}>
                <p style={{margin: "0 0 5px 0",fontSize: "1rem",color: "#555",}}>
                  Periodo de cobro:{" "}
                  <span style={{ fontWeight: "bold", color: "#000" }}>
                    {moment(periodoDeCobro)
                      .locale("es")
                      .format("MMMM [de] YYYY")}
                  </span>
                </p>
                <p style={{margin: "0 0 5px 0",fontSize: "1rem",color: "#555",}}>
                  Fecha de Emisión:{" "}
                  <span style={{ fontWeight: "bold", color: "#000" }}>
                    {fechaDeEmision}
                  </span>
                </p>
                <p style={{ margin: 0, fontSize: "1rem", color: "#555" }}>
                  Vencimiento:{" "}
                  <span style={{ fontWeight: "bold", color: "#000" }}>
                    {vencimiento}
                  </span>
                </p>
              </div>
            </div>
            <div style={{display: "flex",justifyContent: "space-between",marginBottom: "30px",}} >
              {/* Main content */}
              <div style={{ width: "50%" }}>
                <h5>Resumen de Pagos</h5>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={{textAlign: "left",borderBottom: "1px solid #ddd",}}>
                        Item
                      </th>
                      <th
                        style={{textAlign: "right",borderBottom: "1px solid #ddd",}}>
                        Monto
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Arriendo (s)</td>
                      <td style={{ textAlign: "right" }}>
                        $
                        {summary?.arriendoTotal?.toLocaleString("es-CL", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        UF
                      </td>
                    </tr>
                    <tr>
                      <td>Gasto Común</td>
                      <td style={{ textAlign: "right" }}>
                        $
                        {summary?.gastoComunTotal?.toLocaleString("es-CL", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        UF
                      </td>
                    </tr>
                    <tr>
                      <td>Servicios</td>
                      <td style={{ textAlign: "right" }}>
                        $
                        {summary?.serviciosTotal?.toLocaleString("es-CL", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        UF
                      </td>
                    </tr>
                    <tr>
                      <td>Obras Civiles</td>
                      <td style={{ textAlign: "right" }}>
                        $
                        {summary?.obrasCivilesTotal?.toLocaleString("es-CL", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        UF
                      </td>
                    </tr>
                    <tr style={{ marginTop: "20px" }}>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <span style={{fontSize: "1.25rem",marginTop: "20px",fontWeight: "800",}}>
                          Total a pagar:
                          {summary?.total?.toLocaleString("es-CL", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}{" "}
                          UF
                        </span>
                      </td>
                    </tr>
                    <tr style={{ marginTop: "20px" }}>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <span
                          style={{fontSize: "1.25rem",marginTop: "20px",fontWeight: "800",}}>
                          $
                          {summary?.totalClp?.toLocaleString("es-CL", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          })}{" "}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{width: "48%",borderLeft: "1px solid #ddd",paddingLeft: "10px",}}>
                <h5>Formas de Pago</h5>
                <ul style={{ paddingLeft: "20px" }}>
                  <li>Depósito</li>
                  <li>Transferencia Bancaria</li>
                </ul>
                {fila?.empresa === "ALTAMIRA" ? (
                  <table style={{ width: "100%", marginTop: "10px" }}>
                    <tbody>
                      <tr>
                        <td>Banco</td>
                        <td style={{ textAlign: "right" }}>ITAU</td>
                      </tr>
                      <tr>
                        <td>Rut</td>
                        <td style={{ textAlign: "right" }}>76.071.007-5</td>
                      </tr>
                      <tr>
                        <td>Nombre</td>
                        <td style={{ textAlign: "right" }}>ALTAMIRA SA</td>
                      </tr>
                      <tr>
                        <td>Tipo de Cuenta</td>
                        <td style={{ textAlign: "right" }}>Corriente</td>
                      </tr>
                      <tr>
                        <td>N° Cuenta</td>
                        <td style={{ textAlign: "right" }}>2120941106</td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <tbody>
                    <tr>
                      <td>Banco</td>
                      <td style={{ textAlign: "right" }}>ITAU</td>
                    </tr>
                    <tr>
                      <td>Rut</td>
                      <td style={{ textAlign: "right" }}>76.066.122-8</td>
                    </tr>
                    <tr>
                      <td>Nombre</td>
                      <td style={{ textAlign: "right" }}>
                        SOC AGRIC E INMOBILIARIA LA SIEMBRA LTDA
                      </td>
                    </tr>
                    <tr>
                      <td>Tipo de Cuenta</td>
                      <td style={{ textAlign: "right" }}>Corriente</td>
                    </tr>
                    <tr>
                      <td>N° Cuenta</td>
                      <td style={{ textAlign: "right" }}>223286902</td>
                    </tr>
                  </tbody>
                )}
                <Button style={{marginTop: "10px",padding: "10px 15px",color: "white",border: "none",borderRadius: "5px",cursor: "pointer",}} icon="pi pi-copy" onClick={handleCopyDetails}>
                  Copiar Datos
                </Button>
                <div style={{marginTop: "10px",fontWeight: "bold",}}>
                  Valor UF al primer día hábil de{" "}
                  {moment(periodoDeCobro)
                    .locale("es")
                    .format("MMMM [de] YYYY")}
                  :{" "}
                  {`$ ${ufTipoCambio.toLocaleString("es-CL", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}{" "}
                </div>
              </div>
            </div>

            {/* Tables Section */}
            <div>
              {/* Table for Arriendo */}
              {arriendoItems.length > 0 && (
                <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f9f9f9",}}>
                  <h4>Detalle Arriendos</h4>
                  <DataTable
                    value={arriendoItems}
                    dataKey="rowKey"
                  >
                    <Column field="item" header="ITEM" />
                    <Column field="moneda" header="MONEDA" />
                    <Column field="docCobro" header="DOC. COBRO" />
                    <Column
                        field="total"
                        header="TOTAL"
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        body={(rowData) => {
                            const isCLP = rowData.moneda === "CLP"; // Check if the currency is CLP
                            const formattedValue = Number(
                                rowData.total
                            ).toLocaleString("es-CL", {
                                minimumFractionDigits: isCLP ? 0 : 2,
                                maximumFractionDigits: isCLP ? 0 : 2,
                            });
                            return isCLP
                                ? `$ ${formattedValue}`
                                : `${formattedValue} ${rowData.moneda}`;
                        }}
                    />
                    <Column
                        field="totalClp"
                        header="TOTAL CLP"
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        body={(rowData) =>
                            `$ ${Number(rowData.totalClp).toLocaleString(
                                "es-CL",
                                {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                }
                            )}`
                        }
                    />
                  </DataTable>
                </div>
              )}

              {/* Table for Gasto Común */}
              {gastoComunItems.length > 0 && (
                <div style={{marginBottom: "20px",padding: "10px",border: "1px solid #ccc",borderRadius: "5px",backgroundColor: "#f9f9f9",}}>
                  <h4>Detalle Gasto Común</h4>
                  <DataTable
                    value={gastoComunItems}
                    dataKey="rowKey" 
                  >
                    <Column field="item" header="ITEM" />
                    <Column field="moneda" header="MONEDA" />
                    <Column field="docCobro" header="DOC. COBRO" />
                    <Column
                        field="total"
                        header="TOTAL"
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        body={(rowData) => {
                            const isCLP = rowData.moneda === "CLP";
                            const formattedValue = Number(
                                rowData.total
                            ).toLocaleString("es-CL", {
                                minimumFractionDigits: isCLP ? 0 : 2,
                                maximumFractionDigits: isCLP ? 0 : 2,
                            });
                            return isCLP
                                ? `$ ${formattedValue}`
                                : `${formattedValue} ${rowData.moneda}`;
                        }}
                    />
                    <Column
                        field="totalClp"
                        header="TOTAL CLP"
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        body={(rowData) =>
                            `$ ${Number(rowData.totalClp).toLocaleString(
                                "es-CL",
                                {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                }
                            )}`
                        }
                    />
                </DataTable>
                </div>
              )}

              {/* Table for Servicios */}
              {serviciosItems.length > 0 && (
                <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f9f9f9",}}>
                  <h4>Detalle Servicios</h4>
                  <DataTable value={serviciosItems}>

                    <Column field="item" header="ITEM" />
                    <Column field="servicios" header="SERVICIO" />
                    <Column
                        field="lectInicial"
                        header="LECT. IN"
                        body={(rowData) => rowData.lectInicial }
                    />
                    <Column
                        field="lectFinal"
                        header="LECT. FI"
                        body={(rowData) =>
                            rowData.isMask
                                ? (rowData.originalItems || []).reduce(
                                    (acc, ch) => acc + (Number(ch.lectFinal) || 0),
                                    0
                                  )
                                : rowData.lectFinal
                        }
                    />
                    {/* Ajuste: sumar consumo en máscaras */}
                    <Column
                      field="consumo"
                      header="CONSUMO"
                      body={(rowData) => { return rowData.consumo; }}
                    />
                    <Column field="unidadMedida" header="UNIDAD" body={(rowData) => (rowData.isMask ? "m**3" : rowData.unidadMedida)}/>
                    <Column field="moneda" header="MONEDA" />
                    <Column field="docCobro" header="DOC. COBRO" />
                    <Column
                      field="total"
                      header="TOTAL"
                      style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                      body={(rowData) => {
                        const isCLP = rowData.moneda === "CLP";
                        const value = isCLP ? rowData.totalClp : rowData.total;
                        const formattedValue = Number(value).toLocaleString("es-CL", {
                          minimumFractionDigits: isCLP ? 0 : 2,
                          maximumFractionDigits: isCLP ? 0 : 2,
                        });
                        return isCLP ? `$ ${formattedValue}` : `${formattedValue} UF`;
                      }}
                    />
                    <Column
                      field="totalClp"
                      header="TOTAL CLP"
                      style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                      body={(rowData) =>
                        `$ ${Number(rowData.totalClp).toLocaleString(
                          "es-CL",
                          {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }
                        )}`
                      }
                    />
                  </DataTable>
                </div>
              )}

              {/* Table for Obras Civiles */}
              {obrasCivilesItems.length > 0 && (
                <div style={{ marginBottom: "20px", padding: "10px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#f9f9f9",}}>
                  <h4>Detalle Obras Civiles</h4>
                  <DataTable
                    value={obrasCivilesItems}
                    dataKey="rowKey"
                  >
                    <Column field="item" header="ITEM" />
                    <Column field="observador" header="OBSERVADOR" />
                    <Column field="cuotas" header="CUOTAS" />
                    <Column field="moneda" header="MONEDA" />
                    <Column field="docCobro" header="DOC. COBRO" />
                    <Column
                        field="total"
                        header="TOTAL"
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        body={(rowData) => {
                            const isCLP = rowData.moneda === "CLP"; // Check if the currency is CLP
                            const formattedValue = Number(
                                rowData.total
                            ).toLocaleString("es-CL", {
                                minimumFractionDigits: isCLP ? 0 : 2,
                                maximumFractionDigits: isCLP ? 0 : 2,
                            });
                            return isCLP
                                ? `$ ${formattedValue}`
                                : `${formattedValue} ${rowData.moneda}`;
                        }}
                    />
                    <Column
                        field="totalClp"
                        header="TOTAL CLP"
                        style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        body={(rowData) =>
                            `$ ${Number(rowData.totalClp).toLocaleString(
                                "es-CL",
                                {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                }
                            )}`
                        }
                    />
                  </DataTable>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <Button
        onClick={exportToPDF}
        loading={exportLoading}
        disabled={exportLoading}
        label={exportLoading ? "Exportando..." : "Exportar a PDF"}
        className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2 p-button-md"
        raised  
      />
    </Dialog>
  );
};

export default DetallePeriodoCobro;